import React, { useContext, useEffect, useRef, useState } from 'react'
import PropTypes, { func } from 'prop-types'
import classNames from 'classnames'

import { I18nContext } from '../../I18n'
import styles from './Chat.module.css'

function useClickOutside(ref, onClose) {
  useEffect(() => {
    if (!ref.current) return
    
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose()
      }
    }
    
    document.addEventListener('mousedown', handler)
    document.addEventListener('touchstart', handler)
    
    return () => {
      document.removeEventListener('mousedown', handler)
      document.removeEventListener('touchstart', handler)
    }
  }, [ref, onClose])
}

SupportChat.propTypes = {
  chatId: PropTypes.string,
  position: PropTypes.oneOf(['bottom-right', 'bottom-left'])
}
export default function SupportChat({position = 'bottom-right' }) {
  const I18n = useContext(I18nContext);
  const [isMinimized, setIsMinimized] = useState(true)
  const wrapperRef = useRef(null)

  useClickOutside(wrapperRef, () => setIsMinimized(true))

  const handleToggleChat = () => {
    setIsMinimized(prev => !prev)
  }

  // const handleOpenChat = () => {
  //   window.open(`https://max.ru/lunn_university_bot`, '_blank', 'noopener,noreferrer')
  // }

  return (
    <div
      ref={wrapperRef} 
      className={classNames(
      styles.supportChat,
      styles[position],
      { [styles.minimized]: isMinimized }
    )}>
      {!isMinimized && (
        <div className={styles.chatWindow}>
          <div className={styles.chatHeader}>
            <span className={styles.chatTitle}>{I18n.t('pages.index.support.title')}</span>
            <button 
              onClick={handleToggleChat}
              className={styles.chatToggle}
              aria-label="Свернуть чат"
            >
              −
            </button>
          </div>
          
          <div className={styles.chatBody}>
            <p className={styles.greeting}>{I18n.t('pages.index.support.ChatTitle')}</p>
            <p className={styles.message}>
              {I18n.t('pages.index.support.text')}
            </p>
            <div>
              <img width="200" height="200" src='/images/max-qr-code.svg'>
            </img>
            </div>
            
          </div>
          
          <div className={styles.chatFooter}>
            <a 
              href={`https://max.ru/lunn_university_bot`}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.chatButton}
            >
              <svg className={styles.chatIcon} width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2z"/>
              </svg>
              {I18n.t('pages.index.support.button')}
            </a>
          </div>
        </div>
      )}
      
      {isMinimized && (
        <button 
          onClick={handleToggleChat}
          className={styles.chatBubble}
          aria-label="Открыть чат"
        >
          <img width="60" height="60" src='/images/max.png'>
            
          </img>
        </button>
      )}
    </div>
  )
}